import * as React from 'react';
import {Router, Route, hashHistory} from 'react-router';
import App from './Scenes/Layout';
import Weland from './Scenes/Weland2';
import Step2 from './Scenes/Step2';
import Step3 from './Scenes/Step3';
import Step4 from './Scenes/Step4';
import { BlockView } from './Utils/BlockView';


export const routes = (
	<Router history={hashHistory} onUpdate={() => window.scrollTo(0, 0)}>
		<Route component={App}>
			<Route path="/" component={Weland} component={BlockView(Weland)}  />
			<Route path="/2" component={Step2} component={BlockView(Step2)} />
			<Route path="/3" component={Step3} component={BlockView(Step3)} />
			<Route path="/4" component={Step4} component={BlockView(Step4)} />
		</Route>
	</Router>
);


// WEBPACK FOOTER //
// ./src/router.js